import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Utils/NewIcon';
import DefaultTooltip from 'components/Utils/DefaultTooltip';
import UnreadBadge from 'components/Common/UnreadBadge';
import './style.scss';

export const DocumentCheck = ({
  isChecked,
  document,
  toggleDocument,
  documentIndex,
  tooltip = 'The documents will be sent in the order indicated by this number',
}) => (
  <div className="document-check">
    <Icon
      src="circle-check"
      width="32px"
      fontAwesomeStyle="fad"
      className="blue"
      showTooltip={true}
      alt={isChecked ? 'Document selected' : 'Document not selected'}
      iconStyle={{
        '--fa-primary-color': 'white',
        '--fa-secondary-color': isChecked ? '#2693D1' : 'lightgrey',
        '--fa-secondary-opacity': isChecked ? 1.0 : 0.35,
      }}
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        toggleDocument(document);
      }}
    />

    {isChecked ? (
      <DefaultTooltip title={tooltip} arrow={true}>
        <div className="order-badge-overlay">
          <UnreadBadge unreadText={'#' + (documentIndex + 1)} style={{ background: '#42bcdd' }} />
        </div>
      </DefaultTooltip>
    ) : null}
  </div>
);

DocumentCheck.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  document: PropTypes.object.isRequired,
  toggleDocument: PropTypes.func.isRequired,
  documentIndex: PropTypes.number.isRequired,
  tooltip: PropTypes.string,
};

export default DocumentCheck;
